import React, { createContext, FC, ReactNode, useContext, useState } from 'react';
import { Load } from '../../types';

interface DraftsLoadsContext {
    isDrafts: boolean;
    globalIsDirty: number[];
    handleGlobalIsDirtyChange: (loadId: number, isDirty: boolean) => void;
    globalIsDirtyRemove: (loadId: number) => void;
    addSocketStopId: (n: number) => void;
    getIsLoadStale: (load: Load) => boolean;
    resetSocketStopIds: () => void;
}

const DraftsLoadsContext = createContext<DraftsLoadsContext | undefined>(undefined);

interface DraftsLoadsProviderProps {
    isDrafts: boolean;
    children: ReactNode;
}

export const DraftsLoadsProvider: FC<DraftsLoadsProviderProps> = (props) => {
    const { isDrafts, children } = props;
    const [globalIsDirty, setGlobalIsDirty] = useState<number[]>([]);
    const [socketStopIds, setStocketStopIds] = useState<number[]>([]);

    const handleGlobalIsDirtyChange = (loadId: number, isDirty: boolean) => {
        if (isDirty && !globalIsDirty.includes(loadId)) {
            const newGloablIsDirty = [
                ...globalIsDirty,
                loadId,
            ];

            setGlobalIsDirty(newGloablIsDirty);
        } else if (!isDirty) {
            globalIsDirtyRemove(loadId);
        }
    }

    const globalIsDirtyRemove = (loadId: number) => {
        const newGloablIsDirty = globalIsDirty.filter(x => x !== loadId);
        setGlobalIsDirty(newGloablIsDirty);
    }

    const getIsLoadStale = (load: Load) => {
        const loadStopIds = load.stops.map(stop => stop.id);
        return loadStopIds.some(rowId => socketStopIds.includes(rowId));
    }

    const addSocketStopId = (stopId: number) => {
        setStocketStopIds((prevState) => {
            return [
                ...prevState,
                stopId,
            ];
        });
    }

    const resetSocketStopIds = () => {
        setStocketStopIds([]);
    }

    return (
        <DraftsLoadsContext.Provider
            value={{
                isDrafts,
                globalIsDirty,
                handleGlobalIsDirtyChange,
                globalIsDirtyRemove,
                addSocketStopId,
                getIsLoadStale,
                resetSocketStopIds,
            }}
        >
            {children}
        </DraftsLoadsContext.Provider>
    );
}

export const useDraftsLoadsContext = () => {
    const draftsLoadsContext = useContext(DraftsLoadsContext);

    if (draftsLoadsContext === undefined) {
        throw new Error('draftsLoadsContext must be used within a DraftsLoadsProvider');
    }

    return draftsLoadsContext;
}
